/* Safta Bee size guide v2 - 13 Sep 2026
   Data from the Safta Bee master size chart workbook. All figures are GARMENT
   measurements, not body measurements.
   Rollback: copy assets/safta-size-guide-v1-backup.js.liquid over this file. */
(function () {
  var SEQ = 0;
  var ORDER = ['XS','S','M','L','XL','2XL','3XL','4XL'];

  var SUIT = {
    'XS':  { cm:[152.4,119.4,56.0,60.0,26.7,56.0,10.2,89.0],  inch:[60,47,22,23.5,10.5,22,4,35],    band:'167 - 174' },
    'S':   { cm:[160.0,127.0,56.0,63.5,30.5,56.0,10.3,89.0],  inch:[63,50,22,25,12,22,4.2,35],      band:'175 - 179' },
    'M':   { cm:[165.1,132.0,58.4,66.0,31.7,61.0,11.2,91.4],  inch:[65,52,23,26,12.5,24,4.4,36],    band:'180 - 184' },
    'L':   { cm:[170.2,137.0,61.0,68.6,33.0,62.2,12.7,91.4],  inch:[67,54,24,27,13,24.5,5,36],      band:'185 - 192' },
    'XL':  { cm:[177.8,142.2,62.2,71.1,33.0,63.5,14.0,94.0],  inch:[70,56,24.5,28,13,25,5.5,37],    band:'193 - 195' },
    '2XL': { cm:[180.3,147.3,66.0,73.6,34.3,68.6,14.0,99.0],  inch:[71,58,26,29,13.5,27,5.5,39],    band:'195 - 206' },
    '3XL': { cm:[191.8,147.3,68.6,73.6,38.1,75.0,14.0,104.1], inch:[75.5,58,27,29,15,29.5,5.5,41],  band:'207 - 210' },
    '4XL': { cm:[195.6,152.4,71.1,76.2,38.1,77.5,15.2,104.5], inch:[77,60,28,30,15,30.5,6,41.5],    band:'211 +' }
  };
  var JACKET = {
    'XS':  { cm:[61.0,122.0,53.3,61.0,28.0,56.0],  inch:[24,48,21,24,11,22] },
    'S':   { cm:[63.5,127.0,57.0,63.5,28.7,58.4],  inch:[25,50,22.3,25,11.3,23] },
    'M':   { cm:[66.0,132.0,59.7,66.0,29.2,61.0],  inch:[26,52,23.5,26,11.5,24] },
    'L':   { cm:[68.6,137.2,61.0,68.6,33.0,62.3],  inch:[27,54,24,27,13,24.5] },
    'XL':  { cm:[76.2,142.2,63.5,71.1,33.0,64.8],  inch:[30,56,25,28,13,25.5] },
    '2XL': { cm:[78.7,142.2,66.0,71.1,35.6,67.3],  inch:[31,56,26,28,14,26.5] },
    '3XL': { cm:[83.8,147.3,71.1,73.7,35.6,70.0],  inch:[33,58,28,29,14,27.5] },
    '4XL': { cm:[88.9,152.4,72.4,76.2,40.7,72.4],  inch:[35,60,28.5,30,16,28.5] }
  };
  var SUIT_COLS = [['A','Garment length'],['B','Chest, all round'],['C','Across shoulder'],['D','Waist, stretched'],['E','Arm hole'],['F','Sleeve length'],['G','Neck to shoulder'],['H','Back rise']];
  var JACKET_COLS = [['A','Garment length'],['B','Chest, all round'],['C','Across shoulder'],['D','Waist, stretched'],['E','Arm hole'],['F','Sleeve length']];

  /* upper bound of each height band, cm */
  var HBANDS = [['XS',174],['S',180],['M',185],['L',192],['XL',195],['2XL',206],['3XL',210.5],['4XL',215]];
  var H_MIN = 160, H_MAX = 215;
  var C_MIN = 85, C_MAX = 142;
  var EASE = 15;  /* a suit goes over clothes */

  var ALIAS = { XS:'XS', XSMALL:'XS', EXTRASMALL:'XS', XSSMALL:'XS', S:'S', SMALL:'S', M:'M', MEDIUM:'M', MED:'M',
    L:'L', LARGE:'L', XL:'XL', XLARGE:'XL', EXTRALARGE:'XL', '1XL':'XL', '2XL':'2XL', XXL:'2XL', '2XLARGE':'2XL',
    XXLARGE:'2XL', '3XL':'3XL', XXXL:'3XL', '3XLARGE':'3XL', '4XL':'4XL', XXXXL:'4XL', '4XLARGE':'4XL' };
  function norm(v){ return String(v).toUpperCase().replace(/[^A-Z0-9]/g,''); }
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function r1(n){ return Math.round(n*10)/10; }

  /* chest bands: biggest body chest each size takes, cm */
  function chestBands(table){
    var out = [], last = -1;
    for (var i=0;i<ORDER.length;i++){
      var max = table[ORDER[i]].cm[1] - EASE;
      if (max <= last) continue;   /* 3XL repeats 2XL on some charts */
      out.push([ORDER[i], max]); last = max;
    }
    return out;
  }
  function bandFor(bands, v){
    for (var i=0;i<bands.length;i++){ if (v <= bands[i][1]) return i; }
    return bands.length - 1;
  }

  /* ---------- figure ---------- */
  var SUIT_BODY = '<path d="M70 70 L170 70 L206 100 L224 208 L194 216 L174 124 L174 212 L170 368 L130 368 L124 222 L118 368 L78 368 L74 212 L66 124 L46 216 L16 208 L34 100 Z"/>' +
    '<path d="M84 70 C84 32 98 12 120 12 C142 12 156 32 156 70"/>' +
    '<path d="M90 30 H150 M87 42 H153 M85 54 H155" class="sg-mesh"/>';
  var JACKET_BODY = '<path d="M70 70 L170 70 L206 100 L224 208 L194 216 L174 124 L174 250 L66 250 L66 124 L46 216 L16 208 L34 100 Z"/>' +
    '<path d="M84 70 C84 32 98 12 120 12 C142 12 156 32 156 70"/>' +
    '<path d="M90 30 H150 M87 42 H153 M85 54 H155" class="sg-mesh"/>';

  function dim(letter, d, tx, ty, anchor){
    return '<g class="sg__dim" data-letter="' + letter + '"><path d="' + d + '"/>' +
      '<text x="' + tx + '" y="' + ty + '" text-anchor="' + (anchor||'middle') + '">' + letter + '</text></g>';
  }
  function figure(kind){
    var jacket = kind === 'jacket';
    var bottom = jacket ? 250 : 368;
    var dims = dim('A','M236 12 V' + bottom, 228, jacket?135:195, 'end') +
      dim('B','M66 132 H174', 120, 126) +
      dim('C','M70 74 H170', 120, 68) +
      dim('D','M74 ' + (jacket?242:204) + ' H174', 120, jacket?236:198) +
      dim('E','M186 84 V130', 196, 112, 'start') +
      dim('F','M198 98 L214 204', 212, 160, 'start');
    if (!jacket) {
      dims += dim('G','M120 84 H154', 137, 96) + dim('H','M132 136 V220', 142, 182, 'start');
    }
    return '<svg viewBox="0 0 250 ' + (bottom + 14) + '" role="img" aria-label="Where each measurement is taken on the garment">' +
      '<g fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round">' + (jacket?JACKET_BODY:SUIT_BODY) + '</g>' + dims + '</svg>';
  }

  function table(kind, unit){
    var data = kind==='jacket' ? JACKET : SUIT, cols = kind==='jacket' ? JACKET_COLS : SUIT_COLS;
    var h = '<table class="sg__table"><thead><tr><th>Size</th>';
    if (kind==='suit') h += '<th>Fits height (cm)</th>';
    for (var c=0;c<cols.length;c++) h += '<th data-letter="' + cols[c][0] + '" title="' + cols[c][1] + '">' + cols[c][0] + '</th>';
    h += '</tr></thead><tbody>';
    for (var i=0;i<ORDER.length;i++){
      var s = ORDER[i], row = data[s], vals = unit==='inch' ? row.inch : row.cm;
      h += '<tr data-size="' + s + '"><th>' + s + '</th>';
      if (kind==='suit') h += '<td>' + row.band + '</td>';
      for (var j=0;j<vals.length;j++) h += '<td>' + vals[j] + '</td>';
      h += '</tr>';
    }
    return h + '</tbody></table>';
  }
  function keyList(kind){
    var cols = kind==='jacket' ? JACKET_COLS : SUIT_COLS, h = '<ul class="sg__key">';
    for (var i=0;i<cols.length;i++) h += '<li data-letter="' + cols[i][0] + '"><button type="button"><b>' + cols[i][0] + '</b>' + cols[i][1] + '</button></li>';
    return h + '</ul>';
  }

  function variantRadios(kind){
    var sets = document.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input');
    var sized = [], matched = [];
    for (var i=0;i<sets.length;i++){
      var lbl = sets[i].querySelector('.form__label');
      var name = lbl ? lbl.textContent : '';
      if (!/size/i.test(name)) continue;
      sized.push(sets[i]);
      if (kind==='jacket' && /jacket/i.test(name)) matched.push(sets[i]);
      if (kind==='suit' && /suit/i.test(name)) matched.push(sets[i]);
    }
    var use = matched.length ? matched : sized, out = [];
    for (var k=0;k<use.length;k++){
      var rs = use[k].querySelectorAll('input[type=radio]');
      for (var j=0;j<rs.length;j++) out.push(rs[j]);
    }
    return out;
  }
  function pickVariant(size, kind){
    var radios = variantRadios(kind), hit = null;
    for (var i=0;i<radios.length;i++){ if (ALIAS[norm(radios[i].value)] === size){ hit = radios[i]; break; } }
    if (!hit) return 'missing';
    if (hit.disabled || /is-disabled/.test(hit.className)) return 'unavailable';
    var fs = hit.closest('fieldset');
    var label = fs ? fs.querySelector('label[for="' + hit.id + '"]') : null;
    if (label) label.click(); else { hit.checked = true; hit.dispatchEvent(new Event('change',{bubbles:true})); }
    return 'ok';
  }

  function init(root){
    if (root.dataset.sgReady) return;
    root.dataset.sgReady = '1';
    var shell = root.closest('.product-popup-modal__content');
    if (shell) shell.classList.add('sg-modal');

    var uid = 'sg' + (++SEQ);
    var kind = root.getAttribute('data-kind') || 'suit';
    var kinds = kind === 'both' ? ['suit','jacket'] : [kind];
    var active = kinds[0];
    var unit = 'cm';
    var H = 178, C = 104;   /* cm, always stored in cm */

    try { var saved = JSON.parse(localStorage.getItem('saftaSizeGuide')||'null');
      if (saved && saved.h) { H = saved.h; C = saved.c || C; unit = saved.u === 'inch' ? 'inch' : 'cm'; } } catch(e){}

    function toDisp(cm){ return unit==='inch' ? r1(cm/2.54) : r1(cm); }
    function fromDisp(v){ return unit==='inch' ? v*2.54 : v; }
    function u(){ return unit==='inch' ? 'in' : 'cm'; }

    var tabs = '';
    if (kinds.length > 1) {
      tabs = '<div class="sg__tabs" role="tablist">' +
        '<button type="button" class="sg__tab is-active" data-tab="suit">Full suit</button>' +
        '<button type="button" class="sg__tab" data-tab="jacket">Jacket</button></div>';
    }

    root.innerHTML =
      '<div class="sg__hero"><div class="sg__hex">&#128207;</div><div>' +
        '<h4>Find your size in ten seconds</h4>' +
        '<p>Slide to your measurements and we will tell you which size to order. Safta Bee suits are worn over clothes, so the room is already built in.</p>' +
      '</div></div>' +
      tabs +
      '<div class="sg__units" role="group" aria-label="Units">' +
        '<button type="button" class="sg__unit is-active" data-unit="cm">cm</button>' +
        '<button type="button" class="sg__unit" data-unit="inch">inches</button>' +
      '</div>' +
      '<div class="sg__steps"></div>' +
      '<div class="sg__verdict" aria-live="polite"></div>' +
      '<div class="sg__details"><h5>Every measurement, in full</h5>' +
        '<p>These are the finished garment laid flat, not your body. Tap a letter to see where it is taken.</p>' +
        '<div class="sg__panels"></div></div>' +
      '<div class="sg__note"><p>Suits and jackets run 2 to 3 cm longer or shorter in the back length, inside leg and under arm.</p>' +
        '<p>Still unsure? Email customercare@saftabee.co.uk with your height and chest and we will pick for you.</p></div>';

    var stepsEl = root.querySelector('.sg__steps');
    var verdictEl = root.querySelector('.sg__verdict');
    var panelsEl = root.querySelector('.sg__panels');

    function stepHTML(id, label, hint, val, min, max){
      return '<div class="sg__step" data-step="' + id + '">' +
        '<div class="sg__step-top"><span class="sg__step-label">' + label + '</span>' +
          '<span class="sg__readout"><input class="sg__num" id="' + uid + '-' + id + '" type="number" inputmode="decimal" value="' + val + '">' +
          '<span class="sg__unitlabel">' + u() + '</span></span></div>' +
        '<p class="sg__hint">' + hint + '</p>' +
        '<input class="sg__slider" type="range" min="' + min + '" max="' + max + '" step="0.5" value="' + val + '" aria-label="' + label + '">' +
        '<div class="sg__band"></div></div>';
    }

    function renderSteps(){
      var html = '';
      if (active === 'suit') html += stepHTML('h','Your height','Standing, without shoes', toDisp(H), toDisp(H_MIN), toDisp(H_MAX));
      html += stepHTML('c','Your chest','All the way round, at the fullest point', toDisp(C), toDisp(C_MIN), toDisp(C_MAX));
      stepsEl.innerHTML = html;
      stepsEl.style.gridTemplateColumns = (active === 'suit') ? '' : 'minmax(0,1fr)';
      drawBands();
    }

    function bandHTML(bands, lo, hi, value){
      var h = '', prev = lo;
      for (var i=0;i<bands.length;i++){
        var top = Math.min(bands[i][1], hi);
        var w = Math.max(top - prev, 0.6);
        h += '<div class="sg__seg" data-size="' + bands[i][0] + '" style="flex-grow:' + w + '">' + bands[i][0] + '</div>';
        prev = top;
      }
      var pct = Math.min(100, Math.max(0, (value - lo) / (hi - lo) * 100));
      return h + '<div class="sg__marker" style="left:' + pct + '%"></div>';
    }

    function drawBands(){
      var tbl = active==='jacket' ? JACKET : SUIT;
      var hStep = stepsEl.querySelector('[data-step=h] .sg__band');
      if (hStep) hStep.innerHTML = bandHTML(HBANDS, H_MIN, H_MAX, H);
      var cStep = stepsEl.querySelector('[data-step=c] .sg__band');
      if (cStep) cStep.innerHTML = bandHTML(chestBands(tbl), C_MIN, C_MAX, C);
    }

    function compute(){
      var jacket = active === 'jacket';
      var tbl = jacket ? JACKET : SUIT;
      var cb = chestBands(tbl);
      var ci = bandFor(cb, C);
      var byChest = cb[ci][0];
      var byHeight = null, hi = -1;
      if (!jacket){ hi = bandFor(HBANDS, H); byHeight = HBANDS[hi][0]; }
      var pick = byHeight ? (ORDER.indexOf(byHeight) >= ORDER.indexOf(byChest) ? byHeight : byChest) : byChest;
      /* how close to the top of the deciding band */
      var lead = (byHeight && ORDER.indexOf(byHeight) >= ORDER.indexOf(byChest)) ? 'height' : 'chest';
      var edge = false, room = false;
      if (lead === 'height'){
        var lo = hi === 0 ? H_MIN : HBANDS[hi-1][1];
        edge = (HBANDS[hi][1] - H) <= 2; room = (H - lo) <= 2;
      } else {
        var clo = ci === 0 ? C_MIN : cb[ci-1][1];
        edge = (cb[ci][1] - C) <= 2; room = (C - clo) <= 2;
      }
      return { pick: pick, byHeight: byHeight, byChest: byChest, lead: lead, edge: edge, room: room, jacket: jacket };
    }

    function renderVerdict(){
      var v = compute();
      var nextUp = ORDER[Math.min(ORDER.length-1, ORDER.indexOf(v.pick)+1)];
      var headline, sub;
      if (v.edge && nextUp !== v.pick){ headline = 'Size ' + v.pick + ', but you are near the top of it'; sub = 'If you like extra room over thick layers, take ' + nextUp + '.'; }
      else if (v.room){ headline = 'Size ' + v.pick + ', with room to spare'; sub = 'You sit at the generous end of this size.'; }
      else { headline = 'Size ' + v.pick + ' is your fit'; sub = 'You sit comfortably inside this size.'; }

      var why = [];
      if (v.byHeight) why.push('Your height of ' + toDisp(H) + ' ' + u() + ' falls in the ' + SUIT[v.byHeight].band + ' cm band, which is ' + v.byHeight + '.');
      why.push('A ' + toDisp(C) + ' ' + u() + ' chest needs a garment chest of at least ' + toDisp(C + EASE) + ' ' + u() + ', so ' + v.byChest + ' is the smallest that works.');
      if (v.byHeight && v.byHeight !== v.byChest) why.push('The two point at different sizes, so we have taken the larger, as the chart advises.');
      if (v.jacket) why.push('Jackets are sized on the chest alone.');

      var radios = variantRadios(active), canPick = false;
      for (var i=0;i<radios.length;i++){ if (ALIAS[norm(radios[i].value)] === v.pick){ canPick = true; break; } }

      verdictEl.innerHTML =
        '<div class="sg__verdict-main"><div class="sg__badge"><span>' + v.pick + '</span></div>' +
          '<div class="sg__verdict-copy"><div class="sg__verdict-kicker">We recommend</div>' +
          '<div class="sg__verdict-headline">' + esc(headline) + '</div>' +
          '<div class="sg__verdict-sub">' + esc(sub) + '</div></div></div>' +
        '<ul class="sg__why">' + why.map(function(w){ return '<li>' + esc(w) + '</li>'; }).join('') + '</ul>' +
        (canPick ? '<button type="button" class="sg__pick" data-size="' + v.pick + '">Choose size ' + v.pick + '</button>' : '');

      var segs = root.querySelectorAll('.sg__seg');
      for (var s=0;s<segs.length;s++) segs[s].classList.toggle('is-on', segs[s].getAttribute('data-size') === v.pick);
      var rows = root.querySelectorAll('.sg__table tbody tr');
      for (var r=0;r<rows.length;r++) rows[r].classList.toggle('is-match', rows[r].getAttribute('data-size') === v.pick);

      try { localStorage.setItem('saftaSizeGuide', JSON.stringify({h:H, c:C, u:unit})); } catch(e){}
    }

    function renderPanels(){
      panelsEl.innerHTML = kinds.map(function(k){
        return '<div class="sg__panel" data-panel="' + k + '"' + (k===active?'':' hidden') + '>' +
          '<div class="sg__layout"><figure class="sg__figure">' + figure(k) + '</figure>' +
          '<div><div class="sg__scroll">' + table(k, unit) + '</div>' +
          '<p class="sg__swipe">Swipe the table sideways to see every measurement</p>' + keyList(k) + '</div></div></div>';
      }).join('');
    }

    function lit(letter){
      var all = root.querySelectorAll('.sg__dim, .sg__key li, .sg__table thead th');
      for (var i=0;i<all.length;i++){
        var el = all[i];
        el.classList.toggle('is-lit', !!letter && el.getAttribute('data-letter') === letter);
      }
      if (!letter){ var d = root.querySelectorAll('.sg__dim'); for (var j=0;j<d.length;j++) d[j].classList.remove('is-lit'); }
    }

    function redraw(){ renderSteps(); renderPanels(); renderVerdict(); }
    redraw();

    root.addEventListener('input', function(e){
      var t = e.target;
      if (t.classList.contains('sg__slider') || t.classList.contains('sg__num')){
        var step = t.closest('.sg__step').getAttribute('data-step');
        var val = parseFloat(t.value);
        if (isNaN(val)) return;
        var cm = fromDisp(val);
        if (step === 'h') H = Math.min(H_MAX, Math.max(H_MIN, cm)); else C = Math.min(C_MAX, Math.max(C_MIN, cm));
        var box = t.closest('.sg__step');
        var other = t.classList.contains('sg__slider') ? box.querySelector('.sg__num') : box.querySelector('.sg__slider');
        if (other) other.value = toDisp(step==='h'?H:C);
        drawBands(); renderVerdict();
      }
    });

    root.addEventListener('click', function(e){
      var tab = e.target.closest('.sg__tab');
      if (tab){
        active = tab.getAttribute('data-tab');
        var ts = root.querySelectorAll('.sg__tab');
        for (var i=0;i<ts.length;i++) ts[i].classList.toggle('is-active', ts[i]===tab);
        var ps = root.querySelectorAll('.sg__panel');
        for (var j=0;j<ps.length;j++) ps[j].hidden = ps[j].getAttribute('data-panel') !== active;
        renderSteps(); renderVerdict(); return;
      }
      var un = e.target.closest('.sg__unit');
      if (un){
        unit = un.getAttribute('data-unit');
        var us = root.querySelectorAll('.sg__unit');
        for (var k=0;k<us.length;k++) us[k].classList.toggle('is-active', us[k]===un);
        redraw(); return;
      }
      var keyBtn = e.target.closest('.sg__key li');
      var head = e.target.closest('.sg__table thead th[data-letter]');
      var target = keyBtn || head;
      if (target){
        var L = target.getAttribute('data-letter');
        lit(target.classList.contains('is-lit') ? null : L);
        return;
      }
      var pick = e.target.closest('.sg__pick');
      if (pick){
        var res = pickVariant(pick.getAttribute('data-size'), active);
        if (res === 'ok'){
          pick.textContent = 'Size ' + pick.getAttribute('data-size') + ' selected';
          pick.disabled = true;
          var closer = document.querySelector('.product-popup-modal[open] .product-popup-modal__toggle');
          if (closer) setTimeout(function(){ closer.click(); }, 500);
        } else if (res === 'unavailable'){ pick.textContent = 'That size is out of stock'; pick.disabled = true; }
        else { pick.hidden = true; }
      }
    });
  }

  function boot(){ var n = document.querySelectorAll('.sg[data-kind]'); for (var i=0;i<n.length;i++) init(n[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();